import React from 'react';
import { Link } from '@tanstack/react-router';

const logo = '/Musicade-Logo.png';

export const AUTH_DOWNLOAD_URL = 'https://apps.apple.com/us/app/musicade-app/id6747211062';

export const AuthHeader: React.FC = () => {
  return (
    <header className="absolute top-0 left-0 right-0 z-20 flex items-center justify-between px-8 py-6 w-full">
      <Link to="/" className="flex items-center gap-3 cursor-pointer group">
        <img src={logo} alt="Musicade Logo" className="w-8 h-8 object-contain" />
        <div className="flex items-center gap-2">
          <span className="text-white font-['Bebas_Neue'] text-[20px] leading-none tracking-normal uppercase mt-1">
            Musicade
          </span>
          <span className="rounded-full bg-[#2B1A14] px-3 py-1 text-[12px] font-semibold leading-none text-[#F7963B]">
            Beta
          </span>
        </div>
      </Link>
      <a
        href={AUTH_DOWNLOAD_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#782675]/40 hover:bg-[#782675]/60 text-white font-medium text-[14px] inline-flex items-center justify-center rounded-[41px] h-10 px-4 gap-2 backdrop-blur-md transition-colors border-none cursor-pointer"
      >
        Download
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
      </a>
    </header>
  );
};
